import { Error } from '@mui/icons-material';
import { Grid } from '@mui/material';
import { inject, observer } from 'mobx-react';
import QRCode from 'qrcode.react';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import Header from '../common/Header';

@inject('cartStore')
@observer
class QrOrder extends Component {
  async componentDidMount() {
    const { cartStore } = this.props;
    cartStore.clearCart();
  }

  // handleClickDownload = () => {
  //   var $svg = document.getElementById('qrCode');
  //   const data = new XMLSerializer().serializeToString($svg);
  //   const blob = new Blob([data], { type: 'image/svg+xml;charset=utf-8' });
  //   const $canvas = document.createElement('canvas');
  //   const { width, height } = $svg.getBoundingClientRect();
  //   $canvas.width = width;
  //   $canvas.height = height;
  //   const ctx = $canvas.getContext('2d');
  //   const img = new Image();
  //   img.onload = e => {
  //     ctx.drawImage(e.target, 0, 0);
  //     const $link = document.createElement('a');
  //     $link.download = 'image.png';
  //     $link.href = $canvas.toDataURL('image/png');
  //     $link.click();
  //   };

  //   img.src = URL.createObjectURL(blob);
  // };

  render() {
    const { t, match } = this.props;
    return (
      <React.Fragment>
        {/* 헤더 */}
        <Header title={`QR ${t('order.title.main')}`} isGoHome={true} />

        <div className="contents" style={{ minHeight: '100%' }}>
          <Grid
            container
            direction={'column'}
            wrap={'nowrap'}
            justifyContent={'center'}
            alignItems={'center'}
            style={{ minHeight: '100%' }}
          >
            <Grid item>
              <QRCode
                id="qrCode"
                value={'SMARTORDERQRORDER,' + match.params.id}
                renderAs="svg"
                includeMargin={true}
                width={300}
                height={300}
              />
            </Grid>

            <Grid item style={{ marginTop: '10px', textAlign: 'center', fontSize: '18px', fontWeight: 'bold' }}>
              {t('order.text.showQr')
                .split('\n')
                .map((text, index) => (
                  <span key={index}>
                    {text}
                    <br />
                  </span>
                ))}
            </Grid>

            <Grid item style={{ width: '100%', padding: '0 20px', marginTop: '24px' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  border: '1px solid #f5d78e',
                  borderRadius: '12px',
                  backgroundColor: '#fdf6e3',
                  padding: '16px 12px',
                  textAlign: 'left',
                  lineHeight: '1.6',
                }}
              >
                <Error style={{ color: '#f5a623', fontSize: '20px', marginRight: '8px', marginTop: '2px' }} />
                <div>
                  {t('order.text.soldOutGuide1')}
                  <span style={{ color: '#c62828', fontWeight: 'bold' }}>{t('order.text.soldOutGuideEmphasis')}</span>
                  {t('order.text.soldOutGuide2')}
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(withTranslation()(QrOrder));
